import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';
import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
const { config } = require('../api/api');



function LifePersonalInformationQuestions() {

  const base_url = config.baseURL;

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  const signatureRef = useRef();

  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    insurancetype: '',
  });
  const [loading, setLoading] = useState(false);



  const handleqOptionChange = (event) => {

  };
  const [quotationData, setQuotationData] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [Referanceid, setReferanceid] = useState('');
  const [modalMessage, setModalMessage] = useState("");
  const [bmi, setbmi] = useState('')


  const [questionList, setQuestionList] = useState();

  const [questionsData, setQuestionsData] = useState([{
    english: '',
    arabic: '',
    key: '',
    accepted_answer: '',
    isChecked: '',
    isChecked_answer: '',
    details: ''
  }]);


  const [selectedValue, setSelectedValue] = useState('Yes');

  const handleChanges = (e) => {
    setSelectedValue(e.target.value);
  };
  function handleRadioChange(index, isChecked) {
    const updatedQuestionsData = [...questionsData];
    updatedQuestionsData[index] = {
      ...updatedQuestionsData[index],
      isChecked,
      isChecked_answer: isChecked ? "Yes" : "No"
    };
    setQuestionsData(updatedQuestionsData);
  }

  function handleDetailsChange(index, details) {

    const updatedQuestionsData = [...questionsData];
    updatedQuestionsData[index] = {
      ...updatedQuestionsData[index],
      details
    };
    setQuestionsData(updatedQuestionsData);
  }

  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);


  const clearSignature = () => {
    signatureRef.current.clear();
    setIsSignatureEmpty(true); // Disable button after clearing
  };
  const handleSignature = () => {
    if (!signatureRef.current.isEmpty()) {
      setIsSignatureEmpty(false); // Enable button when signature is drawn
    }
  };
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const [userData, setUserData] = useState();

  // useEffect(() => {
  //   const storedUserString = Cookies.get('userData'); //sessionStorage.getItem('userData')
  //   if (storedUserString != undefined) {
  //     const storedUser = JSON.parse(storedUserString);
  //     setUserData(storedUser);
  //   } else {
  //     alert("token expired");
  //     window.location.href = '/';
  //   }
  // }, []);









  const handleSubmit = async (event) => {

    event.preventDefault();
    setLoading(true);

    event.preventDefault();
    window.location.href = '/';



  };
  const [dhofarData, setDhofarData] = useState(false);
  const [age, setAge] = useState(null);
  useEffect(() => {


    const storedDhofarString = Cookies.get('personalData');
    debugger
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      // alert("token expired");
      // window.location.href='/';
    }

  }, []);


  const [vendorKey, setVendorkey] = useState('');

  useEffect(() => {

    const postvData = { organization_name: "Superjet" };
    debugger

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


      fetch( base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]); // Dependency array

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const postData = { token: dhofarData };
  // const today = new Date().toISOString().split('T')[0];
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate() + 1).toISOString().split('T')[0];


  const [dobValue, setdobValue] = useState('');
  const handledobChange = (event) => {
    const selectedDob = event.target.value;
    setdobValue(event.target.value);

    const dobDate = new Date(selectedDob);
    const today = new Date();
    let calculatedAge = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();

    // Adjust age if the current date is before the user's birthday in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      calculatedAge--;
    }

    setAge(calculatedAge);
  };

  const [selectedgenderOption, setSelectedgenderOption] = useState(null);
  const [selectedgenderOptionid, setSelectedgenderOptionid] = useState(null);
  const handlegenderChange = (event) => {
    setSelectedgenderOptionid(event.target.options[event.target.selectedIndex].id);
    setSelectedgenderOption(event.target.value);
  };

  const [selectedmaritalOption, setSelectedmaritalOption] = useState(null);
  const [selectedmaritalOptionid, setSelectedmaritalOptionid] = useState(null);
  const handlemaritalChange = (event) => {
    setSelectedmaritalOptionid(event.target.options[event.target.selectedIndex].id);
    setSelectedmaritalOption(event.target.value);
  };
  //getgender

  const [questions, setquestionsValue] = useState([]);

  useEffect(() => {
    if (vendorKey !== '') {
      const fetchQuestions = async () => {
        try {
          debugger
          const response = await fetch( base_url + '/get_personal_accident_questions', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData),
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          debugger
          setQuestionList(data.result.data);
          var questionsLists = data.result.data;

          questionsLists = questionsLists.map(question => ({
            english: question.English,
            arabic: question.Arabic,
            key: question.key,
            accepted_answer: question.accepted_answer,
            isChecked: '',
            details: '',
            isChecked_answer: ''
          }));
          const getQuestions=sessionStorage.getItem("personalquestionvalue");
          
          if(getQuestions!==undefined&&getQuestions!==null&&getQuestions!==""){
           const homeQuestions =JSON.parse(getQuestions);
          Object.keys(homeQuestions).forEach((prop)=>{
            const currentQuestion = questionsLists.find(question => question.key === prop);
               if (currentQuestion) {
               const updatedQuestionsData = [...questionsLists];
               const updatedQuestion = { ...currentQuestion, isChecked: homeQuestions[prop]==="Yes" ? true : false , isChecked_answer: homeQuestions[prop] };
               updatedQuestionsData[questionsLists.indexOf(currentQuestion)] = updatedQuestion;
               questionsLists = updatedQuestionsData;
  }

  });
          setQuestionsData(questionsLists);
        }
        else{
          setQuestionsData(questionsLists);
          }
        if(getQuestions!==undefined){
           const checkbox =JSON.parse(getQuestions);
           setIsChecked(checkbox.checkbox_checked);
          }
          
          // setQuestionsData(questionsLists);
        } catch (error) {
          console.error('Error fetching occupations:', error);
        }
      };

      fetchQuestions();
    }
  }, [vendorKey]);

  debugger
  // console.log(questions.map(question.index))
  console.log(questions)
  
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [isModalOpen]);


  const api_headers = {
    'Authorization': 'Bearer ' + vendorKey,
    'Content-Type': 'application/json' // Ensure you're sending JSON
  }


const [amount, setAmountValue] = useState('');
const [policy, setPolicyValue] = useState('');











  const handleQotation = async (event) => {

    

  const bacsicinfojson = sessionStorage.getItem('personalaccidentbasicinfo');
    const basicinfo = JSON.parse(bacsicinfojson);

    const basicPremiumjson = sessionStorage.getItem('personalaccidentpremiumcover');
    const basicPremium = JSON.parse(basicPremiumjson);


    const addbenefityjson = sessionStorage.getItem('personalaccidentbeneficiaries');
    const addbenefity = JSON.parse(addbenefityjson);



    const personalinfojson = sessionStorage.getItem('persionalaccidentinformationpage');
    const personalinfo = JSON.parse(personalinfojson);
    setbmi(personalinfo.bmi);

    function formatDOB(dob) {
      const date = new Date(dob);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
  }

    debugger

    var quotation_data =
    {
      "token": dhofarData,
      "cover_type": "Personal Accident",
      "application_type": "self",
      "plan": "Personal Accident",
      "nationality": personalinfo.nationality,
      "civil_id": personalinfo.civilid,
      "sum_assured": basicPremium.assured_value,
      "personalInformation": {
        "fullName": personalinfo.fullName,
        "email": personalinfo.email,
        "mobileNumber": personalinfo.mobilenumber,
        "dob": formatDOB(basicinfo.dob),
        "resident_location": personalinfo.Residential_Location,
        "gender": basicinfo.basicinfo_gender_detail.toLowerCase(),
        "is_married": basicinfo.basicinfo_marital_status_detail.toLowerCase() === "single" ? 'no' : 'yes',
        "height": personalinfo.height,
        "weight": personalinfo.weight,
        "occupation": personalinfo.occupation,
        "occupation_code": personalinfo.occupation_code,
        "passport": personalinfo.passportnumber,
        "vat_in": personalinfo.vat_in,
        "id_expiry_date": formatDOB(personalinfo.id_expiry_date),
      },
      "beneficiaries": addbenefity.beneficiaries
    };
    if (vendorKey !== '') {
      // const fetchPolicy = async () => {
      try {


        const dd = await fetch( base_url + '/get_personal_accident_quotation', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${vendorKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(quotation_data),
        });

        if (!dd.ok) {
          const errData = await dd.json().catch(() => ({}));
          const rawMsg = errData?.result?.errors?.message;
          const errMsg = Array.isArray(rawMsg) ? rawMsg[0] : (typeof rawMsg === 'string' ? rawMsg : 'An error occurred. Please try again.');
          setModalMessage(errMsg);
          setIsErrorModal(true);
          setIsModalOpen(true);
          setLoading(false);
          return;
        }
        debugger

        const data = await dd.json();

        if (data?.result?.errors?.message) {
          const rawMsg = data.result.errors.message;
          const errMsg = Array.isArray(rawMsg) ? rawMsg[0] : (typeof rawMsg === 'string' ? rawMsg : 'An error occurred. Please try again.');
          setModalMessage(errMsg);
          setIsErrorModal(true);
          setIsModalOpen(true);
          setLoading(false);
          return;
        }

        setAmountValue(data.result.data.amount);
        sessionStorage.setItem("personalaccdientamount", JSON.stringify(data.result.data.amount))
        // var questionvalue ={
        //   "suffer_from_impairment_of_sight":questionsData[0].isChecked_answer,
        //   "is_healthy": questionsData[1].isChecked_answer,
        //   "practise_acitivty": questionsData[2].isChecked_answer,
        //   "have_intention_leaving_country": questionsData[3].isChecked_answer,
        //   "have_hazardous_cricumstances": questionsData[4].isChecked_answer,
        //   "have_any_proposal_declined": questionsData[5].isChecked_answer,
        //   "have_pa_declined": questionsData[6].isChecked_answer,
        //   "have_pa_policy": questionsData[7].isChecked_answer,
        //   "have_claimed_compensation": questionsData[8].isChecked_answer,
        //   "signature":signatureRef.current.toDataURL()
        // }

        var questionvalue = questionsData.reduce((acc, q) => {
          acc[q.key] = q.isChecked_answer;
          return acc;
        }, {});
        questionvalue["signature"] = signatureRef.current.toDataURL();
        sessionStorage.setItem('personalquestionvalue', JSON.stringify(questionvalue))
        // await handlePolicy(data.result.data.amount)
        const signatureData=signatureRef.current.toDataURL();
        sessionStorage.setItem("paSignature",signatureData);
        window.location.href = '/life-personalinformation-policy';
      } catch (error) {
        console.error('Error fetching occupations:', error);
        setLoading(false);
      }
      // };


    }
  };


  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Please answer the following' : 'الرجاء الإجابة على ما يلي\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">


              {questionsData.map((question, index) => (
                <div key={index}>
                  <p>{index+1}.{question.english}</p>
                  <div className="custom-radio" style={{color:'#3fd2f2'}}>
                    <input
                      type="radio"
                      id={`yes-${index}`}
                      name={`option-${index}`}
                      value="Yes"
                      checked={question.isChecked === true && question.isChecked_answer==="Yes"}
                      onChange={() => handleRadioChange(index, true)}
                    />
                    <label htmlFor={`yes-${index}`}>Yes</label>

                    <input
                      type="radio"
                      id={`no-${index}`}
                      name={`option-${index}`}
                      value="No"
                      checked={question.isChecked === false&& question.isChecked_answer==="No"}
                      onChange={() => handleRadioChange(index, false)}
                    />
                    <label htmlFor={`no-${index}`}>No</label>
                  </div>
                  <br />
                  {question.isChecked_answer != '' && question.accepted_answer !== question.isChecked_answer && (
                    <div className='col-md-12'>
                      <textarea
                        style={{
                          height: '100px',
                          width: '100%'
                        }}
                        value={question.details || ''} // Ensure there's a default value
                        onChange={(e) => handleDetailsChange(index, e.target.value)}
                        placeholder="Please provide more details"
                      />
                    </div>
                  )}
                </div>
              ))}


             {lnstr=="en"? <b>Please put your signature here</b>:<b>من فضلك وقع هنا</b>}<br />

              <SignatureCanvas
                 ref={(ref)=>{
                  signatureRef.current=ref;
                  const  storedSignature=sessionStorage.getItem("paSignature");
                  if(storedSignature && ref){
                    ref.clear();
                    ref.fromDataURL(storedSignature);
                    setIsSignatureEmpty(false);
                  }

                }}
                penColor="black"
                canvasProps={{ width: 340, height: 200, className: 'sigCanvas' }}
                style={{ border: '1px solid #ccc', backgroundColor: 'white' }} // Ensure background is white
                onEnd={handleSignature} // Detect when drawing ends
              />
              <div>
                <button type="button"
                  style={{ backgroundColor: !isSignatureEmpty ? '#1D3561' : 'grey', borderColor: '#1D3561' }}
                  className="btn btn-primary rounded-pill text-white my-3 py-1 " onClick={async () => {
                    clearSignature();
                  }}
                  disabled={isSignatureEmpty}
                >
                    {t("Clear Signature")}
                </button>
              </div>



              <p ><input type="checkbox" checked={isChecked}
              onChange={handleCheckboxChange} name="note" />
              { lnstr=="en" ? <span>I declare that the above answers are true to the best of my knowledge and belief, that I have disclosed all particulars affecting the assessment of the risk and that I am and always have been of temperate habits. I agree that this proposal and declaration shall be the basis of the contract between me and the Insurers.</span>:<span>أُقرّ بأن الإجابات المذكورة أعلاه صحيحة على حد علمي ومعرفتي، وأنني أفصحت عن جميع التفاصيل المؤثرة في تقييم المخاطر، وأنني كنتُ وما زلتُ أتمتع باعتدال في عاداتي. وأُوافق على أن يكون هذا الاقتراح والإقرار أساسًا للعقد المبرم بيني وبين شركات التأمين.</span>}
            </p>
            <div className='col-md-2 text-center'>
              <button type="button" 
                style={{ backgroundColor: isChecked ? '#1D3561' : "grey", borderColor: '#1D3561' }}
                className="btn btn-primary rounded-pill text-white my-3 py-1 "
                // disabled={isChecked ? false : true}
                onClick={async () => {


                  var question_valid = !questionsData.some(q => q.isChecked_answer === '');
                  const invalidQuestion = questionsData.findIndex(q => q.isChecked_answer !== '' && q.isChecked_answer !== q.accepted_answer && !q.details);
                  const wrongAnswerQuestion = questionsData.findIndex(q => q.isChecked_answer !== q.accepted_answer && q.isChecked_answer !== '');
                  if (!question_valid) {
                    alert('Please ensure the question answer');
                  } else if (wrongAnswerQuestion !== -1) {
                    alert(`Please select the Answer ${questionsData[wrongAnswerQuestion].accepted_answer} in question ${wrongAnswerQuestion + 1}`);
                  } else if (signatureRef.current.isEmpty()) {
                    alert('Please put signature');
                  } else if (!isChecked) {

                    alert('Please ensure the declare');
                  } else {
                    debugger
                    // event.preventDefault();



                    setLoading(true);

                    await handleQotation();
                    
                  }

                }}
              >
                {t("Proceed")}
              </button>
            </div>

            

            </Col>


            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      {isModalOpen && (
        <div style={{ display: 'block', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
          <div style={{ background: '#fff', margin: '10% auto', padding: '20px', width: '50%', borderRadius: '8px' }}>
            {isErrorModal ? (
              <>
                <h4 style={{ color: 'red' }}>&#10006; Error</h4>
                <p>{modalMessage}</p>
                <button className="btn btn-danger" onClick={() => { setIsModalOpen(false); setIsErrorModal(false); }}>Close</button>
              </>
            ) : (
              <>
                <h4>&#10003; Thank you for contacting Dhofar Insurance Company</h4>
                <p>{modalMessage}</p>
                <button className="btn btn-primary" onClick={() => { setIsModalOpen(false); window.location.href = '/life-personalinformationquestions'; }}>Close</button>
              </>
            )}
          </div>
        </div>
      )}

    </Fragment>
  );
}

export default LifePersonalInformationQuestions;
